/**
 * Bus Search Config'leri
 * Merkezi export dosyası
 */

export {
  BUS_PASSENGER_TYPES,
  createBusPassengerConfig,
  createDynamicBusPassengerConfig,
  defaultBusPassengerConfig,
  busPassengerDisplayFormatter,
} from "./passengerConfig";

export { busPassengerGeneralValidations } from "./generalValidations";

// Gelecekte eklenecek diğer search config'leri buradan export edilebilir
// export * from "./locationConfig";
// export * from "./dateConfig";
// export * from "./filterConfig";

